import React from "react";
import PropTypes from "prop-types";
import { LinkKeepUTM } from "../../../shared/components/LinkKeepUTM";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@material-ui/core";

import { formattedDate } from "../../../shared/formattedDate";
import { SortableTableHead } from "../../../shared/components/sortableTableHead";
import { TheadTable } from "../theadTable";

import { PARTICIPANT_HOME_PATH } from "../../../shared/consts/participantHomePath";
import { useStyles } from "./styles";

const headers = [
  {
    id: "Title",
    label: "Title",
    sortable: true,
    numeric: false,
    disablePadding: false,
    cellProps: {
      width: "20%",
    },
  },
  {
    id: "ContentType",
    label: "Type of content",
    sortable: true,
    numeric: false,
    disablePadding: false,
  },
  {
    id: "AssignedAt",
    label: "Date Assigned",
    sortable: true,
    numeric: false,
    disablePadding: false,
  },
  {
    id: "AssignedBy",
    label: "Assigned By",
    sortable: true,
    numeric: false,
    disablePadding: false,
  },
];

export const AssignedContentTable = ({
  content,
  order,
  orderBy,
  onSortChange,
  filters,
}) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer
        className="FiltersContainer"
        width="100%"
        component={Paper}
      >
        <TheadTable filters={filters} />
      </TableContainer>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <SortableTableHead
            fields={headers}
            onRequestSort={onSortChange}
            order={order}
            orderBy={orderBy}
          />
          <TableBody>
            {content.map(
              ({
                assignedContentId,
                contentId,
                contentType,
                title,
                assignedAt,
                assignedBy,
              }) => (
                <TableRow key={contentId}>
                  <TableCell>
                    <LinkKeepUTM
                      to={`${PARTICIPANT_HOME_PATH}/assignedContent/${assignedContentId}/details`}
                      className={[classes.tTruncate, classes.link].join(" ")}
                    >
                      {title}
                    </LinkKeepUTM>
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <span className={classes.tTruncate}>{contentType}</span>
                  </TableCell>
                  <TableCell>
                    <span className={classes.tTruncate}>
                      {assignedAt !== null ? formattedDate(assignedAt) : ""}
                    </span>
                  </TableCell>
                  <TableCell>
                    <span className={classes.tTruncate}>{assignedBy}</span>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

AssignedContentTable.propTypes = {
  content: PropTypes.instanceOf(Object),
  order: PropTypes.string,
  orderBy: PropTypes.string,
  onSortChange: PropTypes.func,
  filters: PropTypes.instanceOf(Array).isRequired,
};

AssignedContentTable.defaultProps = {
  content: [
    {
      contentId: 0,
      name: "",
      description: "",
      contentTypeId: 0,
    },
  ],
  order: "asc",
  orderBy: "",
  onSortChange: (f) => f,
};
